module.exports = __webpack_public_path__ + "static/media/nachrichten.013ee1dd.png";